package com.lomdaat.ads.internal

import io.ktor.client.HttpClient
import io.ktor.client.engine.js.Js
import io.ktor.client.plugins.contentnegotiation.ContentNegotiation
import io.ktor.serialization.kotlinx.json.json
import kotlinx.serialization.json.Json

internal actual fun createAdsHttpClient(json: Json): HttpClient = HttpClient(Js) {
    install(ContentNegotiation) {
        json(json)
    }
}
